module.exports = __webpack_public_path__ + "media/images/quote-695518366108915779a58d71ee47d809.svg";